import React, {useState} from 'react';

import {Column, Row} from '../../../components/layout';
import RegisterHeader from '../../../components/headers/register-header';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {addToWizard, setWizard} from '../../../store/actions';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../../components/forms';
import * as Yup from 'yup';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import Header2 from '../../../components/headers/header2';
import Header1 from '../../../components/headers/header1';
import * as fonts from '../../../util/fonts';
import './styles.scss';
import colors from '../../../util/colors';
import {get} from '../../../api/api';
import {uriGetUserByTaxNumberCMD} from '../../../api/endpoints';
import {createGUID, getDateInServerFormat} from '../../../util/utility';
import {Link, useHistory} from 'react-router-dom';
import {post} from '../../../api/api';
import {uriPostConsentReceipts} from '../../../api/endpoints';
import MyProfilePopup from '../../register/communications/myProfile-popup/MyProfilePopup';
import moment from 'moment';
import {ITenant} from '../../../App';

export interface CommunicationsProps {
  wizard: any;
  addToWizard(value: any): void;
  labels: typeof strings.pt.registoCMD;
  oneTrust: typeof strings.pt.oneTrust;
  setShowAccountData(value: any): void;
  setShowCommunications(value: any): void;
  busFuncMapDefault: any;
  tenant: ITenant;
}

const validationSchema = Yup.object().shape({
  marketingCommunication: Yup.boolean().required(),
  healthAdvices: Yup.boolean().required(),
});

function Communications(props: CommunicationsProps) {
  const {addToWizard, wizard, oneTrust, labels, busFuncMapDefault, tenant} =
    props;
  const [submitting, setSubmitting] = useState(false);

  const [oneTrustIsVisible, setOneTrustIsVisible] = useState(
    busFuncMapDefault?.[functionalitiesAliasMap.oneTrust]
  );

  const history = useHistory();

  const featureName = 'CommunicationsCMD';

  const [showMyProfile, setShowMyProfile] = useState(false);

  const nif = wizard.insuranceValidation.nif;
  const token = oneTrust?.tokenMyAdv;
  const acceptedTermsAndConditions =
    props.wizard.insuranceValidation.acceptedTermsAndConditions;
  const acceptedDataTreatment =
    props.wizard.insuranceValidation.acceptedDataTreatment;
  let purposes: any = [];

  const generateBody = (communicationsConsents: any) => {
    if (acceptedTermsAndConditions) {
      purposes.push({Id: oneTrust?.purposeTermsAndConditions});
    }
    if (acceptedDataTreatment) {
      purposes.push({Id: oneTrust?.purposePolicyDataTreatment});
    }
    if (communicationsConsents.marketingCommunication) {
      purposes.push({Id: oneTrust?.purposeMarketingComunications});
    }
    if (communicationsConsents.healthAdvices) {
      purposes.push({Id: oneTrust?.purposeHealthPrevention});
    }
    return JSON.stringify({
      identifier: nif,
      test: true,
      requestInformation: token,
      purposes: purposes,
    });
  };

  const onSubmit = async (values: any) => {
    setSubmitting(true);
    const communications = {
      marketingCommunication: values.marketingCommunication,
      healthAdvices: values.healthAdvices,
    };

    try {
      const {nif} = props.wizard.insuranceValidation;
      await get(uriGetUserByTaxNumberCMD(nif), false, 0, featureName).then(
        (res: any) => {
          if (res.status === 500) {
            throw new Error(res.detail);
          }
          if (res.isRegisteredInWSO2) {
            history.push('/utilizador-existente');
          } else {
            const dataValidation = {state: 'CLIENT'};
            addToWizard({dataValidation});
          }

          addToWizard({communications});
          const body = generateBody(communications);
          try {
            oneTrustIsVisible &&
              post(uriPostConsentReceipts(), body, false, featureName);
            props.setShowAccountData(true);
            props.setShowCommunications(false);
          } catch (e: any) {}
        }
      );
    } catch (e: any) {
      if (e.status === 404) {
        const dataValidation = {state: 'NOT_FOUND'};
        addToWizard({dataValidation});
        addToWizard({communications});
        const body = generateBody(communications);
        try {
          oneTrustIsVisible &&
            post(uriPostConsentReceipts(), body, false, featureName);
          props.setShowAccountData(true);
          props.setShowCommunications(false);
        } catch (e: any) {}
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Row className="register-container app-center">
        <Column className="communications-container-column">
          <AppForm
            className="communications-form-container"
            initialValues={{
              marketingCommunication: false,
              healthAdvices: false,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => onSubmit(values)}>
            <Row className="communications-header">
              <Header1
                style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
                className="header-communications">
                {labels?.registoCMD_beforeContinueTitle}
              </Header1>
              <Header1
                style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
                className="header-communications-responsive">
                {labels?.registoCMD_beforeContinueTitle}
              </Header1>
            </Row>
            <Row className="center">
              <Column>
                <Row>
                  <p
                    style={{...fonts.ML}}
                    className="register-before-continue-subtitle1">
                    {labels?.registoCMD_beforeContinueMarketingSubtitle}
                  </p>
                </Row>
                <Row className="communications-checkbox-row">
                  <AppFormCheckboxField
                    showErrorMessage
                    purposeId={oneTrust?.purposeMarketingComunications}
                    name="marketingCommunication"
                    className="communications-checkbox"
                    label={
                      <label
                        style={{...fonts.SM, ...fonts.Medium}}
                        className="align-left-label">
                        {labels?.registoCMD_beforeContinueCheckbox1Text}
                        <Link
                          className="communications-anchor"
                          to="#"
                          onClick={() => setShowMyProfile(true)}>
                          {
                            labels?.registoCMD_beforeContinueCheckbox1LinkMyProfile
                          }
                        </Link>
                      </label>
                    }
                  />
                </Row>
                <div>
                  <MyProfilePopup
                    show={showMyProfile}
                    setShowModal={setShowMyProfile}
                  />
                </div>
                <Row>
                  <p
                    style={{...fonts.ML}}
                    className="register-before-continue-subtitle2">
                    {labels?.registoCMD_beforeContinueHealthSubtitle}
                  </p>
                </Row>
                <Row className="communications-checkbox-row">
                  <AppFormCheckboxField
                    showErrorMessage
                    purposeId={oneTrust?.purposeHealthPrevention}
                    name="healthAdvices"
                    className="communications-checkbox"
                    label={
                      <label
                        style={{...fonts.SM, ...fonts.Medium}}
                        className="align-left-label">
                        {labels?.registoCMD_beforeContinueCheckbox2Text1}
                        <Link
                          className="communications-anchor"
                          to="#"
                          onClick={() => setShowMyProfile(true)}>
                          {
                            labels?.registoCMD_beforeContinueCheckbox2LinkMyProfile
                          }
                        </Link>
                        {labels?.registoCMD_beforeContinueCheckbox2Text2}
                      </label>
                    }
                  />
                </Row>
                <Row className="app-center">
                  <AppFormSubmitButton
                    disabled={submitting}
                    className="communications-button"
                    title={labels?.registoCMD_beforeContinueButton}
                  />
                </Row>
              </Column>
            </Row>
          </AppForm>
        </Column>
      </Row>
    </Column>
  );
}

const mapStateToProps = ({
  wizard,
  strings,
  stringsDefault,
  busFuncMapDefault,
  tenant,
}: any) => ({
  wizard: wizard.value,
  labels: strings.value.pt.registoCMD,
  oneTrust: stringsDefault.value.pt.oneTrust,
  busFuncMapDefault: busFuncMapDefault.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(Communications)
);
